<div class="loader d-flex align-items-center justify-content-center">
	<img src="/assets/dixon-logo-small_upscaled.png" width="50" alt="logo" class="logo-margin" />
</div>
